'use client';
import { Link } from "@/i18n/navigation";
import { cn } from "@/lib/utils";
import { Icon } from "@ama-pt/agora-design-system";
import React from "react";

interface LinkProps {
  label?: string;
  url: any;
  target?: string;
  className?: string;
  hasIcon?: boolean;
  ref?: React.LegacyRef<HTMLAnchorElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLAnchorElement>;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  removestyle?: boolean
}

export default function BupiLink({
  label,
  url,
  target,
  hasIcon,
  className,
  ref,
  onKeyDown,
  onClick,
  removestyle
}: LinkProps) {
  return (
    <Link
      key={label}
      href={url}
      target={target}
      aria-label={"Navegar para página " + label}
      ref={ref}
      onKeyDown={onKeyDown}
      onClick={onClick}
      className={cn(`${removestyle && "fill-focus"} py-16 group !text-m-semibold bupi-hover-text dark hover:decoration-primary-700 w-full agora-anchor-link-primary flex items-center justify-between gap-8 md:justify-start text-[#0a6b54]`, className)}
    >
      {label}
      {hasIcon && (
        <>
          <Icon
            name="agora-line-arrow-right-circle"
            className={cn(`w-6 h-6 group-hover:hidden ${removestyle && className} `)}
            aria-hidden="true"
          />

          <Icon
            name="agora-solid-arrow-right-circle"
            className={`w-6 h-6 hidden group-hover:block ${ removestyle && className} `}
            aria-hidden="true"
          />
        </>
      )}
    </Link>
  );
}
